import { apiService } from './axios.client';

export const RegionEndPoints = {
	getAllRegions: function (input, callback) {
		apiService.get('/region/getAll')
			.then((response) => callback(response, input.props))
			.catch(error => alert(error.response.data.message));
	}
};